import React, { useEffect, useReducer, useState } from "react";
import FirebaseHandler from "../index";
import authReducer, { AuthActionKeyType, initialAuthState } from "./reducer";
import { loadUserClaims, loadUserData } from "../util";
import { onAuthStateChanged } from "firebase/auth";
var AuthContext = /*#__PURE__*/ React.createContext([initialAuthState, function () { }]);
export var AuthContextProvider = function AuthContextProvider(_ref) {
    var children = _ref.children;
    var _useState = useState(false), authAvailable = _useState[0], setAuthAvailable = _useState[1];
    var authContext = useReducer(authReducer, initialAuthState, undefined);
    var _ = authContext[0], dispatch = authContext[1];
    useEffect(function () {
        var unregisterAuthObserver = onAuthStateChanged(FirebaseHandler.auth, function (user) {
            setAuthAvailable(true);
            if (user) {
                dispatch({
                    type: AuthActionKeyType.LOGIN,
                    payload: {
                        user: {
                            email: user.email,
                            uid: user.uid
                        }
                    }
                });
                loadUserData(user.uid).then(function (data) {
                    return dispatch({
                        type: AuthActionKeyType.USER_DATA_SUCCESS,
                        payload: {
                            data: data
                        }
                    });
                }).catch(function (error) {
                    return dispatch({
                        type: AuthActionKeyType.USER_DATA_ERROR,
                        payload: {
                            error: error
                        }
                    });
                });
                loadUserClaims().then(function (data) {
                    return dispatch({
                        type: AuthActionKeyType.USER_CLAIMS_SUCCESS,
                        payload: {
                            data: data
                        }
                    });
                }).catch(function (error) {
                    return dispatch({
                        type: AuthActionKeyType.USER_CLAIMS_ERROR,
                        payload: {
                            error: error
                        }
                    });
                });
            }
            else {
                dispatch({
                    type: AuthActionKeyType.LOGOUT
                });
            }
        });
        return function () {
            return unregisterAuthObserver();
        };
    }, []); // Wait with render until we know whether a user is logged in or not to prevent glitches
    if (!authAvailable || authContext === null) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AuthContext.Provider, {
        value: authContext
    }, children);
};
export default AuthContext;
